// ios 版本更新内容
let ios = {
  '1.1.5': {
    title: '蚂蚁报信1.1.5版本更新说明',
    content: [
      {
        text: '1、蚂蚁报信的群聊中，群主或者群管理员，在七天内，可以把群组成员发出的消息撤回；',
      },
      {
        text: '2、在蚂蚁报信聊天信息中，打开网页链接后，增加网页分享到蚂蚁社群和微信；',
      },
      {
        text: '3、增加邀请好友图文介绍模板，在“我的”-->“邀请好友”中，可以分享到微信好友、朋友圈，邀请好友下载注册；另外扫一扫我的二维码，可以自动加为好友，不需要朋友同意；',
      },
      {
        text: '4、一个群组成员数量限制默认500人，一个社群可以添加多个群组或子社群，添加群组的数量没有限制，社群总成员数量默认3000人，若需要增加成员需要做申请并认证；一个用户的通讯录中好友数量可以超过5000人;',
      },
      {
        text: '5、自己邀请的人注册后直接自动加入通讯录中的好友清单，同时也会收到被邀请人注册的消息通知，可以在通讯录中找他/她聊天;',
      },
      {
        text: '6、用户下载注册后，自动加入蚂蚁学院的群组，随着用户增多，群组会自动增加，在本社群内可以咨询、提问与交流，可以获得新零售的创客知识培训等;',
      },
      {
        text: '7、群主可以设置“群聊邀请审核”开关，默认关闭；当设置打开时，群组成员邀请朋友加入，需要群主同意，群组管理员可以直接拉人加入；',
      },
      {
        text: '8、群主可以设置“群组是否公开”开关，默认关闭；当设置打开时，其他用户可以在“联系人详情”的“他的群组”中选择加入公开的群组；',
      },
      {
        text: '9、今天发布，Andriod 版本上腾讯应用宝、小米、华为、OPPO应用商城。',
      }
    ]
  },
  '1.1.6': {
    title: '蚂蚁报信1.1.6版本更新说明',
    content:[
      {
        text: '1、增加蚂蚁报信首页的搜索功能，搜索手机号/昵称/群组名称/报信号；'
      },
      {
        text: '2、好友注册通知栏，点击后可以直接进入好友聊天界面；'
      },
      {
        text: '3、增加切换帐号功能，支持多个蚂蚁报信帐号之间切换，没有数量限制；'
      },
      {
        text: '4、增加邀请好友模板，增加邀请者的头像和昵称；'
      },
      {
        text: '5、添加好友功能中，增加“热门社群”功能, 当设置社群为公开社群时，就会出现在热门社群列表上，其他用户就可以申请加入社群，没有加入的人数限制；'
      },
      {
        text: '6、添加好友功能中，增加“新人推荐”功能, 当在“我的”“更多”资料中设置参与新人推荐时，就会出现在新人推荐列表上，用户可以申请加好友，没有好友数量限制；'
      },
      {
        text: '7、添加好友功能中，增加“Ta手机通讯录保存有你的手机号码”功能，当在Ta的手机通讯录中保存有你的手机号码时，就会出现在列表上，用户可以申请加好友，没有好友数量限制；'
      },
      {
        text: '8、注册后，取消自动加入蚂蚁学院；需要加入者，在热门社群里面申请加入蚂蚁学院；'
      },
      {
        text: '9、增加个签在“我的主页”中显示出来；'
      },
      {
        text: '10、增加手工升级功能，增加升级版本内容说明；'
      },
      {
        text: '11、增加”标记已读”,便于取消社群的消息数字显示；'
      },
      {
        text: '12、增加社群解散功能，社群删除并退出；'
      },
      {
        text: '13、一级用户管理中，增加对一级用户的直属下级用户的人数统计管理，增加与一级用户聊天、拨打电话功能；'
      },
      {
        text: '14、群组的二维码，增加分享到微信、朋友圈的分享功能，内含用户的邀请码，邀请好友在微信中扫码下载蚂蚁报信APP和安装注册后，自动加入本群组里，有最多500人数的限制；'
      },
      {
        text: '15、社群的二维码，增加分享到微信、朋友圈的分享功能，内含用户的邀请码，邀请好友在微信中扫码下载蚂蚁报信APP和安装注册后，自动加入本社群里，没有人数的限制；'
      }
    ]
  },
  '1.2.0': {
    title: '蚂蚁报信1.2.0版本更新说明',
    content: [
      {
        text: '1、蚂蚁社群中，增加蚂蚁直播圈，直播发起直播、直播回看；'
      },
      {
        text: '2、蚂蚁社群中，增加蚂蚁交流圈，支持不限人数的交流；'
      },
      {
        text: '3、蚂蚁群组中，增加蚂蚁直播圈，直播发起直播、直播回看；'
      },
      {
        text: '4、蚂蚁商城上线，目前仅支持微课和知识云店，支持知识内容商品发布、上架和管理；'
      },
      {
        text: '5、蚂蚁号上线，目前仅支持资讯内容更新；'
      },
      {
        text: '6、蚂蚁双会员系统，支持平台会员系统（会员、创客、导师）和云店会员系统（三星或五星会员系统）;'
      },
      {
        text: '7、云店管家，支持云店会员系统插件、分销功能插件和商家公众号插件；'
      },
      {
        text: '8、任务列表，支持直播内容审核，审核员有下架、停止等权限；'
      },
      {
        text: '9、直播模式（图文直播、音频直播、视频直播），增加互动直播、教育白板直播模式；'
      },
      {
        text: '10、发现模块，支持热门蚂蚁社群、热门蚂蚁云店和蚂蚁省购（链接京东、淘宝、拼多多等商城网页）；'
      },
      {
        text: '11、收藏功能，实现商品收藏；'
      }
    ]
  },
  '1.3.0': {
    title: '蚂蚁报信1.3.0版本更新说明',
    content: [
      {
        text: '1、蚂蚁报信中增加聊天记录收藏以及聊天记录多选功能'
      },
      {
        text: '2、蚂蚁社群中增加蚂蚁交流圈功能，支持不限人数交流'
      },
      {
        text: '3、蚂蚁商城中增加云店礼包以及VIP店展示功能'
      },
      {
        text: '4、蚂蚁开店页面增加一键加入社群以及加入了商家APP和官网推广入口'
      },
      {
        text: '5、蚂蚁双会员系统，支持平台会员系统（普通会员，银牌会员，金牌会员）和云店会员系统（一星到五星会员系统）'
      },
      {
        text: '6、部分已知问题的修复和改进'
      }
    ]
  },
  '1.3.3': {
    title: '蚂蚁报信1.3.3版本更新说明',
    content: [
      {
        text: '1、电商直播。直播间右下角新增添加商品按钮，支持直播间直接购买商品'
      },
      {
        text: '2、增加蚂蚁号一级入口。蚂蚁号为APP互动社区，支持发布长文、图片、外链文章、加群入口等，让商家和用户随时随地获得新鲜资讯以及蚂蚁好友日常分享。支持商家和用户发布信息功能陆续上线中'
      },
      {
        text: '3、会员礼包。支持多门课程打包售卖,商家打包出售便捷，学员购买更实惠'
      }
    ]
  },
  '1.4.0': {
    title: '蚂蚁报信1.4.0版本更新说明',
    content: [
      {
        text: '1、增加会员礼包的订单信息。用户购买会员礼包后，可在订单处查询购买情况，且商家可在订单中查看礼包售卖情况。'
      },
      {
        text: '2、增加APP的分享方式。所有转发支持图片扫码分享、链接分享。'
      },
      {
        text: '3、部分已知问题的修复和改进。'
      }
    ]
  },
  '1.4.1': {
    title: '蚂蚁报信1.4.1版本更新说明',
    content: [
      {
        text: '1、增加账号注销功能。用户可对账号进行注销，注销后将不可用该账号进行注册或登录。'
      },
      {
        text: '2、增加蚂蚁号文章分类显示。可选择查看全部、推荐或好友的蚂蚁号文章。'
      },
      {
        text: '3、修复了部分手机兼容性问题。'
      }
    ]
  },
  '1.5.0': {
    title: '蚂蚁报信1.5.0版本更新说明',
    content: [
      {
        text: '1、新增省购商城。用户可通过商城购买实体商品，购买后可查看订单及物流信息，且支持售后服务。'
      },
      {
        text: '2、部分已知问题的修复和改进。'
      }
    ]
  },
  '1.5.2': {
    title: '蚂蚁报信1.5.2版本更新说明',
    content: [
      {
        text: '1、优化省购商城。对商品搜索功能及商品分类展示进行优化，用户在浏览商品时体验更佳。'
      },
      {
        text: '2、新增商品分销模式。用户可在平台上开店，分销省购商品，从而获得奖励。'
      },
      {
        text: '3、新增购物奖励模块。用户购买商品后赠送的金币，可在该模块中查看统计及明细。'
      },
      {
        text: '4、新增蚂蚁号手机发布。用户可在手机上发布蚂蚁号文章，及查看蚂蚁号文章列表，且可进行管理。'
      },
      {
        text: '5、部分已知问题的修复和改进。'
      },
    ]
  },
  '1.5.3': {
    title: '蚂蚁报信1.5.3版本更新说明',
    content: [
      {
        text: '1、新增年货专区。用户可直接进入此专区购买年货商品，享受优惠价格。'
      },
      {
        text: '2、新增金币专区。用户可直接进入此专区购买可金币抵扣的商品。'
      },
      {
        text: '3、更换商城主题风格。更换商城新年主题，增加节日气氛。'
      },
      {
        text: '4、部分已知问题的修复和改进。'
      },
    ]
  },
  '1.5.5': {
    title: '蚂蚁报信1.5.5版本更新说明',
    content: [
      {
        text: '1、新增表情包及最近使用。新增22个表情，用户在发送表情时有更多的选择；同时，新增最近使用表情页面，此页面展示最近使用的表情，用户选择起来更便捷。'
      },
      {
        text: '2、优化蚂蚁号用户体验。发布蚂蚁号时，新增标题录入项，用户可自由选择是否填写。'
      },
      {
        text: '3、调整社群人数上限。由原本500人上升至2000人。'
      },
      {
        text: '4、优化社群管理员权限。管理员不能添加或移除管理员；管理员可设置群内陌生人是否可互相加好友。'
      },
      {
        text: '5、部分已知问题的修复和改进。'
      },
    ]
  },
  '3.0.0': {
    title: '云柑社区3.0.0版本更新说明',
    content: [
      {
        text: '1、APP名称正式更换为云柑社区。'
      },
      {
        text: '2、更改了原本的大部分功能排布。'
      },
      {
        text: '3、首页功能修改为以短视频为主的社区。用户可新建社区。'
      },
      {
        text: '4、增加商圈功能。'
      },
      {
        text: '5、发现-蚂蚁号正式更改为好友圈、蚂蚁组织正式更改为云柑组织、蚂蚁商城正式更改为云柑商城。'
      },
      {
        text: '6、我的增加商家端功能。'
      },
      {
        text: '7、修改已知bug。'
      },
    ]
  },
  '3.1.0': {
    title: '云柑社区3.1.0版本更新说明',
    content: [
      {
        text: '1、首页细分不同标签内容。'
      },
      {
        text: '2、支持列表模式、全屏模式供用户使用。'
      },
      {
        text: '3、发布内容支持文字、视频、图片、联系方式。增加内容有效时间功能。'
      },
      {
        text: '4、增加点赞、转发、评论功能。'
      },
      {
        text: '5、增加点击头像即可聊天功能。'
      },
      {
        text: '6、发现增加好友动态、好友视频入口。'
      },
      {
        text: '7、发现增加访客系统功能。'
      },
      {
        text: '8、修改已知bug。'
      },
    ]
  },
  
  
  
}
export default ios